var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "custom-order-select" }, [
    _c(
      "div",
      [
        _c(
          "div",
          {
            on: {
              click: function($event) {
                _vm.open = !_vm.open
              }
            }
          },
          [
            _c("div", [
              _c("p", { staticClass: "mb-0" }, [
                _vm.selected
                  ? _c("b", [
                      _c("span", [_vm._v(_vm._s(_vm.selected.name))]),
                      _vm._v(" "),
                      _c("span", {
                        class:
                          _vm.selected.dir === "up"
                            ? "mdi mdi-arrow-up"
                            : "mdi mdi-arrow-down"
                      })
                    ])
                  : _c("b", [_vm._v(_vm._s(_vm.placeholder))])
              ])
            ])
          ]
        ),
        _vm._v(" "),
        _c("transition", { attrs: { name: "dropdown" } }, [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.open,
                  expression: "open"
                }
              ],
              staticClass: "dropdown-list",
              on: {
                mouseleave: function($event) {
                  _vm.open = false
                }
              }
            },
            _vm._l(_vm.list, function(item, index) {
              return _c(
                "div",
                {
                  key: index,
                  class: item.dir,
                  on: {
                    click: function($event) {
                      return _vm.onClick(item)
                    }
                  }
                },
                [
                  _c("span", [_vm._v(_vm._s(item.name))]),
                  _vm._v(" "),
                  _c("span", {
                    class:
                      item.dir === "up"
                        ? "mdi mdi-arrow-up"
                        : "mdi mdi-arrow-down"
                  })
                ]
              )
            }),
            0
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5294c03f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5294c03f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/CustomOrderSelect.vue
// module id = null
// module chunks = 